import React from 'react';
import { AppProvider } from './src/context/AppContext';
import { SERVICES_ROUTE } from './src/utils/routes';
import { handleScrollToTop } from './src/utils/functions';
// import useVinSchema from './src/hooks/useVinSchema';
import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/vendor/normalize.css';
import './src/styles/vendor/fonts.css';
import './src/styles/vendor/scrollbar.css';

export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
    });
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <AppProvider>
      {element}
    </AppProvider>
  )
}

